import { type FC } from 'react';
import QRCode, { type QRCodeProps } from 'react-qr-code';

import { LogoImage } from 'svg';

type QrDisplayerProps = Omit<QRCodeProps, 'size' | 'value' | 'ref'> & {
  value: string;
  size?: number;
};

const LOGO_THRESHOLD = 70;

const QrDisplayer: FC<QrDisplayerProps> = ({ value, size = 128, level, ...rest }) => {
  if (!value) return null;
  const showLogo = size >= LOGO_THRESHOLD;
  const resolvedLevel = level ?? (showLogo ? 'H' : 'L');
  const logoSize = Math.round(size * 0.26);

  return (
    <div
      style={{
        position: 'relative',
        width: size,
        height: size,
        display: 'inline-block',
      }}
    >
      <QRCode value={value} size={size} level={resolvedLevel} {...rest} />
      {showLogo && (
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: logoSize,
            height: logoSize,
            background: '#fff',
            borderRadius: 4,
            padding: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxSizing: 'border-box',
          }}
        >
          <LogoImage style={{ width: '100%', height: '100%' }} />
        </div>
      )}
    </div>
  );
};

export default QrDisplayer;
